export default "__VITE_ASSET__ClOMxXtz__"